import { render, staticRenderFns } from "./BaseCursorPagination.vue?vue&type=template&id=00dda9cd&scoped=true"
import script from "./BaseCursorPagination.vue?vue&type=script&lang=js"
export * from "./BaseCursorPagination.vue?vue&type=script&lang=js"
import style0 from "./BaseCursorPagination.vue?vue&type=style&index=0&id=00dda9cd&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00dda9cd",
  null
  
)

export default component.exports